import { gql } from '@apollo/client';

const CREATE_PREREQUISIT_SET = gql`
    mutation createPrerequisiteSet( $input:CreatePrerequisiteSetInput! ) {
        Result: createPrerequisiteSet( input:$input ) {
            id
            objectId
            operator
            type
            prerequisites {
                objectId
                weight
            }
        }
    }`
;

export default CREATE_PREREQUISIT_SET;